import axios from 'axios';

export default {
    fetchAll() {
        return axios.post('/language/fetchAll/');
    },
};
